import { combineReducers } from '@reduxjs/toolkit';
import { reducer as SessionReducer } from '@store/session';
import { reducer as UserReducer } from '@store/user';
import { reducer as StatisticsReducer } from '@store/statistics';
import { reducer as SystemReducer } from '@store/system';
export default combineReducers({
    session: SessionReducer,
    user: UserReducer,
    statistics: StatisticsReducer,
    system: SystemReducer,
});
